import { css } from 'styled-components';

export const Print = css`
  @media print {
    [data-no-print] {
      display: none !important;
    }
    * {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    .site-content {
      .container {
        filter: blur(0) !important;
      }
    }
  }

  @page {
    margin: 0;
  }
`;
